import {
  HasDisplayName3s4kfsms5h38b as HasDisplayName,
  get_shortDisplayNamenwyz2dxtvf5g as get_shortDisplayName,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__times_impl_hlr6p72nff9ykdm2zvo as MonetaryValue__times_impl_hlr6p7,
  LineItemInterface2ct3y0vtnbxod as LineItemInterface,
} from '../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Companion_getInstancenv8qpb0wanrh as Companion_getInstance } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../../theming/AppColors.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  firstOrNullf6vlo6vdgu1e as firstOrNull,
  single3ds7xj9roxi5z as single,
  sortedWith2csnbbb21k0lg as sortedWith,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  isComplete3isyniin1qz2u as isComplete,
  isPendingCompletion65tdr7y6lgp6 as isPendingCompletion,
} from '../../../../../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
import { percentComplete22ixcedvdan2 as percentComplete } from '../../../../../utils/utils.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { Companion_getInstance3vjikuur3h0k4 as Companion_getInstance_0 } from '../../../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_displayColor() {
  return this.fg0().laz();
}
var DirectlyDisplayableStateClass;
function DirectlyDisplayableState() {
  if (DirectlyDisplayableStateClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'DirectlyDisplayableState', VOID, VOID, [HasDisplayName()]);
    DirectlyDisplayableStateClass = $;
  }
  return DirectlyDisplayableStateClass;
}
function color(_this__u8e3s4) {
  var tmp0_safe_receiver = isInterface(_this__u8e3s4, DirectlyDisplayableState()) ? _this__u8e3s4 : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.fg0();
  return tmp1_elvis_lhs == null ? Companion_getInstance().acz(_this__u8e3s4.h90()) : tmp1_elvis_lhs;
}
var PayAppStatus_Draft_instance;
var PayAppStatus_Pending_instance;
var PayAppStatus_Review_instance;
var PayAppStatus_Partial_instance;
var PayAppStatus_Denied_instance;
var PayAppStatus_Approved_instance;
var PayAppStatus_Voided_instance;
var PayAppStatus_entriesInitialized;
function PayAppStatus_initEntries() {
  if (PayAppStatus_entriesInitialized)
    return Unit_instance;
  PayAppStatus_entriesInitialized = true;
  PayAppStatus_Draft_instance = PayAppStatus().bhj('Draft', 0, 'Draft', AppColors_getInstance().ffz_1.xg9_1);
  PayAppStatus_Pending_instance = PayAppStatus().bhj('Pending', 1, 'Submitted', AppColors_getInstance().cfz_1.xg9_1, AppColors_getInstance().ifz_1.xg9_1);
  PayAppStatus_Review_instance = PayAppStatus().bhj('Review', 2, 'Open - Partial', AppColors_getInstance().efz_1.xg9_1);
  PayAppStatus_Partial_instance = PayAppStatus().bhj('Partial', 3, 'Closed - Partial', AppColors_getInstance().efz_1.xg9_1);
  PayAppStatus_Denied_instance = PayAppStatus().bhj('Denied', 4, 'Closed - Unpaid', AppColors_getInstance().hfz_1.xg9_1);
  PayAppStatus_Approved_instance = PayAppStatus().bhj('Approved', 5, 'Paid', AppColors_getInstance().dfz_1.xg9_1);
  PayAppStatus_Voided_instance = PayAppStatus().bhj('Voided', 6, 'Voided', AppColors_getInstance().hfz_1.xg9_1);
}
var PayAppStatusClass;
function PayAppStatus() {
  if (PayAppStatusClass === VOID) {
    class $ extends Enum() {
      static bhj(name, ordinal, displayName, color, itemColor) {
        itemColor = itemColor === VOID ? color : itemColor;
        var $this = this.c4(name, ordinal);
        $this.vhf_1 = displayName;
        $this.whf_1 = color;
        $this.xhf_1 = itemColor;
        return $this;
      }
      g90() {
        return this.vhf_1;
      }
      fg0() {
        return this.whf_1;
      }
      i90() {
        return 0;
      }
    }
    protoOf($).h90 = get_displayColor;
    protoOf($).f90 = get_shortDisplayName;
    initMetadataForClass($, 'PayAppStatus', VOID, VOID, [DirectlyDisplayableState(), Enum()]);
    PayAppStatusClass = $;
  }
  return PayAppStatusClass;
}
function get_status(_this__u8e3s4) {
  return !(_this__u8e3s4.w6v_1 == null) ? PayAppStatus_Voided_getInstance() : !(_this__u8e3s4.v6v_1 == null) ? PayAppStatus_Denied_getInstance() : !(_this__u8e3s4.u6v_1 == null) ? PayAppStatus_Approved_getInstance() : _this__u8e3s4.y6v_1 == null ? PayAppStatus_Draft_getInstance() : PayAppStatus_Pending_getInstance();
}
var PayAppItemStatus_Pending_instance;
var PayAppItemStatus_Denied_instance;
var PayAppItemStatus_Approved_instance;
var PayAppItemStatus_Voided_instance;
var PayAppItemStatus_entriesInitialized;
function PayAppItemStatus_initEntries() {
  if (PayAppItemStatus_entriesInitialized)
    return Unit_instance;
  PayAppItemStatus_entriesInitialized = true;
  PayAppItemStatus_Pending_instance = PayAppItemStatus().chj('Pending', 0, 'Submitted', AppColors_getInstance().cfz_1.xg9_1);
  PayAppItemStatus_Denied_instance = PayAppItemStatus().chj('Denied', 1, 'Waited', AppColors_getInstance().hfz_1.xg9_1);
  PayAppItemStatus_Approved_instance = PayAppItemStatus().chj('Approved', 2, 'Paid', AppColors_getInstance().dfz_1.xg9_1);
  PayAppItemStatus_Voided_instance = PayAppItemStatus().chj('Voided', 3, 'Voided', AppColors_getInstance().hfz_1.xg9_1);
}
var PayAppItemStatusClass;
function PayAppItemStatus() {
  if (PayAppItemStatusClass === VOID) {
    class $ extends Enum() {
      static chj(name, ordinal, displayName, color) {
        var $this = this.c4(name, ordinal);
        $this.phf_1 = displayName;
        $this.qhf_1 = color;
        return $this;
      }
      g90() {
        return this.phf_1;
      }
      fg0() {
        return this.qhf_1;
      }
      i90() {
        return 0;
      }
    }
    protoOf($).h90 = get_displayColor;
    protoOf($).f90 = get_shortDisplayName;
    initMetadataForClass($, 'PayAppItemStatus', VOID, VOID, [DirectlyDisplayableState(), Enum()]);
    PayAppItemStatusClass = $;
  }
  return PayAppItemStatusClass;
}
function get_individualStatus(_this__u8e3s4) {
  return !(_this__u8e3s4.w6v_1 == null) ? PayAppItemStatus_Voided_getInstance() : !(_this__u8e3s4.v6v_1 == null) ? PayAppItemStatus_Denied_getInstance() : !(_this__u8e3s4.u6v_1 == null) ? PayAppItemStatus_Approved_getInstance() : PayAppItemStatus_Pending_getInstance();
}
function overallStatus(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4.i1()) {
    tmp = PayAppStatus_Draft_getInstance();
  } else {
    if (_this__u8e3s4.p1() === 1) {
      tmp = single(_this__u8e3s4);
    } else {
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(_this__u8e3s4, Collection())) {
          tmp_0 = _this__u8e3s4.i1();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s = _this__u8e3s4.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (element.equals(PayAppStatus_Pending_getInstance())) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
        tmp$ret$0 = false;
      }
      if (tmp$ret$0) {
        tmp = PayAppStatus_Review_getInstance();
      } else {
        var tmp$ret$2;
        $l$block_2: {
          // Inline function 'kotlin.collections.none' call
          var tmp_1;
          if (isInterface(_this__u8e3s4, Collection())) {
            tmp_1 = _this__u8e3s4.i1();
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp$ret$2 = true;
            break $l$block_2;
          }
          var _iterator__ex2g4s_0 = _this__u8e3s4.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            if (element_0.equals(PayAppStatus_Pending_getInstance()) || element_0.equals(PayAppStatus_Draft_getInstance())) {
              tmp$ret$2 = false;
              break $l$block_2;
            }
          }
          tmp$ret$2 = true;
        }
        if (tmp$ret$2) {
          tmp = PayAppStatus_Partial_getInstance();
        } else {
          var tmp0_elvis_lhs = firstOrNull(_this__u8e3s4);
          tmp = tmp0_elvis_lhs == null ? PayAppStatus_Draft_getInstance() : tmp0_elvis_lhs;
        }
      }
    }
  }
  return tmp;
}
var LineItemWithPaymentInfoClass;
function LineItemWithPaymentInfo() {
  if (LineItemWithPaymentInfoClass === VOID) {
    class $ {
      constructor(lineItem, payApp, activePayApps, cutoff) {
        this.rhc_1 = lineItem;
        this.shc_1 = payApp;
        this.thc_1 = activePayApps;
        this.uhc_1 = cutoff;
        var tmp = this;
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.thc_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.m1();
        while (_iterator__ex2g4s.n1()) {
          var item = _iterator__ex2g4s.o1();
          var tmp0_safe_receiver = item.y6v_1;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.takeUnless' call
            var tmp_1;
            if (!(tmp0_safe_receiver.y26(this.uhc_1) > 0)) {
              tmp_1 = tmp0_safe_receiver;
            } else {
              tmp_1 = null;
            }
            tmp_0 = tmp_1;
          }
          var tmp4_submitted = tmp_0;
          var tmp1_safe_receiver = item.w6v_1;
          var tmp_2;
          if (tmp1_safe_receiver == null) {
            tmp_2 = null;
          } else {
            // Inline function 'kotlin.takeUnless' call
            var tmp_3;
            if (!(tmp1_safe_receiver.q54_1.y26(this.uhc_1) > 0)) {
              tmp_3 = tmp1_safe_receiver;
            } else {
              tmp_3 = null;
            }
            tmp_2 = tmp_3;
          }
          var tmp5_voided = tmp_2;
          var tmp2_safe_receiver = item.u6v_1;
          var tmp_4;
          if (tmp2_safe_receiver == null) {
            tmp_4 = null;
          } else {
            // Inline function 'kotlin.takeUnless' call
            var tmp_5;
            if (!(tmp2_safe_receiver.q54_1.y26(this.uhc_1) > 0)) {
              tmp_5 = tmp2_safe_receiver;
            } else {
              tmp_5 = null;
            }
            tmp_4 = tmp_5;
          }
          var tmp6_approved = tmp_4;
          var tmp3_safe_receiver = item.v6v_1;
          var tmp_6;
          if (tmp3_safe_receiver == null) {
            tmp_6 = null;
          } else {
            // Inline function 'kotlin.takeUnless' call
            var tmp_7;
            if (!(tmp3_safe_receiver.b95().y26(this.uhc_1) > 0)) {
              tmp_7 = tmp3_safe_receiver;
            } else {
              tmp_7 = null;
            }
            tmp_6 = tmp_7;
          }
          var tmp7_denied = tmp_6;
          var tmp$ret$8 = item.d6w(VOID, VOID, VOID, VOID, tmp6_approved, tmp7_denied, tmp5_voided, VOID, tmp4_submitted);
          destination.v(tmp$ret$8);
        }
        tmp.vhc_1 = destination;
        var tmp_8 = this;
        var tmp_9;
        if (isComplete(this.rhc_1.kfy())) {
          tmp_9 = this.rhc_1.v91();
        } else {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = this.vhc_1;
          // Inline function 'kotlin.collections.filterTo' call
          var destination_0 = ArrayList().w();
          var _iterator__ex2g4s_0 = tmp0.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element = _iterator__ex2g4s_0.o1();
            if (!(element.u6v_1 == null)) {
              destination_0.v(element);
            }
          }
          // Inline function 'com.crowpay.extensions.sumMoney' call
          var sum = Companion_instance.p91(0n);
          var _iterator__ex2g4s_1 = destination_0.m1();
          while (_iterator__ex2g4s_1.n1()) {
            var element_0 = _iterator__ex2g4s_1.o1();
            var tmp_10 = sum;
            var tmp$ret$14 = element_0.t6v_1;
            sum = MonetaryValue__plus_impl_c1ylt(tmp_10, tmp$ret$14);
          }
          tmp_9 = sum;
        }
        tmp_8.whc_1 = tmp_9;
        var tmp_11 = this;
        var tmp_12;
        if (isPendingCompletion(this.rhc_1.kfy())) {
          tmp_12 = MonetaryValue__minus_impl_jw9qyp(this.rhc_1.v91(), this.whc_1);
        } else {
          // Inline function 'kotlin.collections.filter' call
          var tmp0_0 = this.vhc_1;
          // Inline function 'kotlin.collections.filterTo' call
          var destination_1 = ArrayList().w();
          var _iterator__ex2g4s_2 = tmp0_0.m1();
          while (_iterator__ex2g4s_2.n1()) {
            var element_1 = _iterator__ex2g4s_2.o1();
            if (element_1.b6w_1) {
              destination_1.v(element_1);
            }
          }
          // Inline function 'com.crowpay.extensions.sumMoney' call
          var sum_0 = Companion_instance.p91(0n);
          var _iterator__ex2g4s_3 = destination_1.m1();
          while (_iterator__ex2g4s_3.n1()) {
            var element_2 = _iterator__ex2g4s_3.o1();
            var tmp_13 = sum_0;
            var tmp$ret$19 = element_2.t6v_1;
            sum_0 = MonetaryValue__plus_impl_c1ylt(tmp_13, tmp$ret$19);
          }
          tmp_12 = sum_0;
        }
        tmp_11.xhc_1 = tmp_12;
        var tmp_14 = this;
        var tmp0_safe_receiver_0 = this.shc_1;
        tmp_14.yhc_1 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.t6v_1;
        var tmp_15 = this;
        var tmp_16;
        if (isComplete(this.rhc_1.kfy())) {
          tmp_16 = this.rhc_1.v91();
        } else {
          var tmp_17 = MonetaryValue__plus_impl_c1ylt(this.whc_1, this.xhc_1);
          var tmp0_elvis_lhs = this.yhc_1;
          var tmp_18;
          var tmp_19 = tmp0_elvis_lhs;
          if ((tmp_19 == null ? null : new (MonetaryValue())(tmp_19)) == null) {
            tmp_18 = Companion_instance.p91(0n);
          } else {
            tmp_18 = tmp0_elvis_lhs;
          }
          tmp_16 = MonetaryValue__plus_impl_c1ylt(tmp_17, tmp_18);
        }
        tmp_15.zhc_1 = tmp_16;
        this.ahd_1 = percentComplete(this.zhc_1, this.v91());
      }
      zhi(retention) {
        return MonetaryValue__times_impl_hlr6p7(this.zhc_1, retention);
      }
      toString() {
        return 'LineItemWithPaymentInfo(lineItem=' + toString(this.rhc_1) + ', payApp=' + toString_0(this.shc_1) + ', activePayApps=' + toString(this.thc_1) + ', cutoff=' + this.uhc_1.toString() + ')';
      }
      hashCode() {
        var result = hashCode(this.rhc_1);
        result = imul(result, 31) + (this.shc_1 == null ? 0 : this.shc_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.thc_1) | 0;
        result = imul(result, 31) + this.uhc_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LineItemWithPaymentInfo()))
          return false;
        if (!equals(this.rhc_1, other.rhc_1))
          return false;
        if (!equals(this.shc_1, other.shc_1))
          return false;
        if (!equals(this.thc_1, other.thc_1))
          return false;
        if (!this.uhc_1.equals(other.uhc_1))
          return false;
        return true;
      }
      k20() {
        return this.rhc_1.lf9_1;
      }
      q91() {
        return this.rhc_1.nf9_1;
      }
      v91() {
        return this.rhc_1.v91();
      }
      r91() {
        return this.rhc_1.mf9_1;
      }
    }
    initMetadataForClass($, 'LineItemWithPaymentInfo', VOID, VOID, [LineItemInterface()]);
    LineItemWithPaymentInfoClass = $;
  }
  return LineItemWithPaymentInfoClass;
}
function percentComplete_0(_this__u8e3s4) {
  // Inline function 'com.crowpay.extensions.sumMoney' call
  var sum = Companion_instance.p91(0n);
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp = sum;
    var tmp$ret$0 = element.zhc_1;
    sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$0);
  }
  var tmp_0 = sum;
  // Inline function 'com.crowpay.extensions.sumMoney' call
  var sum_0 = Companion_instance.p91(0n);
  var _iterator__ex2g4s_0 = _this__u8e3s4.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    var tmp_1 = sum_0;
    var tmp$ret$2 = element_0.v91();
    sum_0 = MonetaryValue__plus_impl_c1ylt(tmp_1, tmp$ret$2);
  }
  var tmp$ret$3 = sum_0;
  return percentComplete(tmp_0, tmp$ret$3);
}
function retentionToDate(_this__u8e3s4, retention) {
  // Inline function 'com.crowpay.extensions.sumMoney' call
  var sum = Companion_instance.p91(0n);
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp = sum;
    var tmp$ret$0 = element.zhi(retention);
    sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$0);
  }
  return sum;
}
function getPaymentData(_this__u8e3s4, data, payApp) {
  var allItems = _this__u8e3s4.baj(data.hgt());
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = allItems.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (element.r6v_1.equals(payApp.i6y_1)) {
      destination.v(element);
    }
  }
  var thisPayAppItems = destination;
  var tmp$ret$3;
  $l$block: {
    // Inline function 'kotlin.collections.minOfOrNull' call
    var iterator = thisPayAppItems.m1();
    if (!iterator.n1()) {
      tmp$ret$3 = null;
      break $l$block;
    }
    var tmp0_elvis_lhs = iterator.o1().l96();
    var minValue = tmp0_elvis_lhs == null ? Companion_getInstance_0().f1m_1 : tmp0_elvis_lhs;
    while (iterator.n1()) {
      var tmp0_elvis_lhs_0 = iterator.o1().l96();
      var v = tmp0_elvis_lhs_0 == null ? Companion_getInstance_0().f1m_1 : tmp0_elvis_lhs_0;
      if (compareTo(minValue, v) > 0) {
        minValue = v;
      }
    }
    tmp$ret$3 = minValue;
  }
  var tmp0_elvis_lhs_1 = tmp$ret$3;
  var firstReview = tmp0_elvis_lhs_1 == null ? Companion_getInstance_0().f1m_1 : tmp0_elvis_lhs_1;
  var project = _this__u8e3s4.eaj(data.jfy());
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = _this__u8e3s4.baj(data.tgm());
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList().w();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = tmp0.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$7;
    $l$block_0: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_1 = thisPayAppItems.m1();
      while (_iterator__ex2g4s_1.n1()) {
        var element_1 = _iterator__ex2g4s_1.o1();
        if (element_1.s6v_1.equals(element_0.kf9_1)) {
          tmp$ret$7 = element_1;
          break $l$block_0;
        }
      }
      tmp$ret$7 = null;
    }
    var associated = tmp$ret$7;
    var tmp1_elvis_lhs = associated == null ? null : associated.y6v_1;
    var cutoff = tmp1_elvis_lhs == null ? firstReview : tmp1_elvis_lhs;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_0 = _this__u8e3s4.baj(data.bgt());
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList().w();
    var _iterator__ex2g4s_2 = tmp0_0.m1();
    while (_iterator__ex2g4s_2.n1()) {
      var element_2 = _iterator__ex2g4s_2.o1();
      if (element_2.a6h_1.equals(element_0.kf9_1)) {
        destination_1.v(element_2);
      }
    }
    var tmp2_safe_receiver = element_0.sfy(cutoff, destination_1, project.h7c_1);
    var tmp;
    if (tmp2_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_2 = ArrayList().w();
      var _iterator__ex2g4s_3 = allItems.m1();
      while (_iterator__ex2g4s_3.n1()) {
        var element_3 = _iterator__ex2g4s_3.o1();
        var tmp_0;
        var tmp_1;
        var tmp_2;
        if (!element_3.q6v_1.equals(associated == null ? null : associated.q6v_1)) {
          tmp_2 = element_3.s6v_1.equals(tmp2_safe_receiver.kf9_1);
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp_1 = element_3.w6v_1 == null;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          var tmp_3;
          if (!(associated == null) && associated.y6v_1 == null) {
            tmp_3 = true;
          } else {
            // Inline function 'kotlin.let' call
            var it = element_3.y6v_1;
            tmp_3 = (!(it == null) && it.y26(cutoff) < 0);
          }
          tmp_0 = tmp_3;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          destination_2.v(element_3);
        }
      }
      tmp = new (LineItemWithPaymentInfo())(tmp2_safe_receiver, associated, destination_2, cutoff);
    }
    var tmp0_safe_receiver = tmp;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.v(tmp0_safe_receiver);
    }
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_4 = getPaymentData$lambda;
  var tmp$ret$26 = new (sam$kotlin_Comparator$0())(tmp_4);
  return sortedWith(destination_0, tmp$ret$26);
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.dhj_1 = function_0;
      }
      wi(a, b) {
        return this.dhj_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.dhj_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function getPaymentData$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.rhc_1.hf9_1;
  var tmp$ret$1 = b.rhc_1.hf9_1;
  return compareValues(tmp, tmp$ret$1);
}
function PayAppStatus_Draft_getInstance() {
  PayAppStatus_initEntries();
  return PayAppStatus_Draft_instance;
}
function PayAppStatus_Pending_getInstance() {
  PayAppStatus_initEntries();
  return PayAppStatus_Pending_instance;
}
function PayAppStatus_Review_getInstance() {
  PayAppStatus_initEntries();
  return PayAppStatus_Review_instance;
}
function PayAppStatus_Partial_getInstance() {
  PayAppStatus_initEntries();
  return PayAppStatus_Partial_instance;
}
function PayAppStatus_Denied_getInstance() {
  PayAppStatus_initEntries();
  return PayAppStatus_Denied_instance;
}
function PayAppStatus_Approved_getInstance() {
  PayAppStatus_initEntries();
  return PayAppStatus_Approved_instance;
}
function PayAppStatus_Voided_getInstance() {
  PayAppStatus_initEntries();
  return PayAppStatus_Voided_instance;
}
function PayAppItemStatus_Pending_getInstance() {
  PayAppItemStatus_initEntries();
  return PayAppItemStatus_Pending_instance;
}
function PayAppItemStatus_Denied_getInstance() {
  PayAppItemStatus_initEntries();
  return PayAppItemStatus_Denied_instance;
}
function PayAppItemStatus_Approved_getInstance() {
  PayAppItemStatus_initEntries();
  return PayAppItemStatus_Approved_instance;
}
function PayAppItemStatus_Voided_getInstance() {
  PayAppItemStatus_initEntries();
  return PayAppItemStatus_Voided_instance;
}
//region block: exports
export {
  get_displayColor as get_displayColor1gavqb36ugd6h,
  DirectlyDisplayableState as DirectlyDisplayableStatebtdfi3611j0b,
  color as color1u2lxyvdop1o6,
  getPaymentData as getPaymentData33dmvsrmw11t5,
  get_individualStatus as get_individualStatus1waisigfu538t,
  overallStatus as overallStatus206eg9g5yqouc,
  percentComplete_0 as percentComplete3fgrixlhykhs9,
  retentionToDate as retentionToDate2zguzqcc0ysu7,
  get_status as get_status1qu684t7g7eh,
  PayAppStatus_Approved_getInstance as PayAppStatus_Approved_getInstance1spuu4f2mfbic,
  PayAppStatus_Denied_getInstance as PayAppStatus_Denied_getInstance3qemqfv8kyvuv,
  PayAppStatus_Draft_getInstance as PayAppStatus_Draft_getInstance171ihe7xpmy9q,
  PayAppStatus_Pending_getInstance as PayAppStatus_Pending_getInstance2ma8qo3my1dmm,
  PayAppStatus_Voided_getInstance as PayAppStatus_Voided_getInstance1gkfpgvkvjp6x,
};
//endregion

//# sourceMappingURL=data.mjs.map
